import React from "react";

import { BarraBusqueda } from "./BarraBusqueda";

export function BarraBusquedaPC(props) {
  return <BarraBusqueda buttonSearch={props.buttonSearch} />;
}
